<template lang="pug">
  v-flex 
    v-card
      v-card-title Productos
        v-spacer
        v-text-field(v-model='search' append-icon='fa-search' label='Buscar producto' single-line hide-details)
        MassiveProductDialog
        Crear_producto_dialog
      v-data-table.elevation-1(:headers='headers' :items='productsRecord' :search='search' key='key')
        template(v-slot:item.action='{item}')
          v-btn(color='secondary' icon @click='editItem(item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='deleteItem(item.key)')
            v-icon(small) far fa-trash-alt

</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import tipo_unidad_de_medida from '@/jsons/tipo_de_unidad_de_medida.json'
export default {
  data:()=>({
      headers: [
        { text: 'Código', value: 'codigo' },
        { text: 'Descripción', value: 'descripcion' },
        { text: 'Presentación', value: 'presentacion' },
        { text: 'Tipo de producto', value: 'codigo_producto_sunat' },
        { text: 'Unidad de medida', value: 'nombre_unidad_de_medida' },
        {text:'Acciones',value:'action'}
      ],
      search: '',
      tipo_unidad_de_medida
  }),
  methods:{
    ...mapActions({
      editItem: 'Product/get',
      deleteItem: 'Product/clean',
      clearForm: 'Product/clearForm',
    }),
  },

  computed: {
    ...mapGetters({
      productsRecord: 'Product/record',
      productTypeRecord: 'ProductType/record',
    }),
    ...mapState({
      data: state=> state.Product.data,
      Product: state=> state.Product,
    }),
  },
  
  components: {
    MassiveProductDialog: ()=>import('.././components/MassiveProductDialog'),
    Crear_producto_dialog: ()=>import('.././components/crear_producto_dialog')
  },
}
</script>
